import React from 'react'
import PropTypes from 'prop-types';
import * as Autosuggest from 'react-autosuggest';
import Component from "../../components/Component";
import IsolatedScroll from "react-isolated-scroll";
import {withFormsy} from "formsy-react";
import LoadingSpinner from "../LoadingSpinner";

class SearchInput extends Component
{
    SearchRequest = null;

    constructor(props)
    {
        super(props);

        this.autoSuggestRef = React.createRef();

        let searchSuggestions = props.suggestions || [];

        if (!props.searchRequestEndpoint) {

            if (laravel[this.props.searchType]) {
                for (let [id, name] of Object.entries(laravel[this.props.searchType])) {
                    searchSuggestions.push({
                        id, name
                    })
                }
            }

        }

        this.state = {
            ...this.state,
            search: this.getSuggestionDisplay(this.props.value) || '',
            suggestions: props.suggestions || [],
            isDisabled: props.disabled,
            isLoading: false,
            formId: this.getId(props),
            searchSuggestions
        };
    }

    getId(props) {
        let _a = props, id = _a.id, label = _a.label, name = _a.name;
        if (id !== '') {
            return id;
        }
        let inString = JSON.stringify(label), hash = 0;

        for (let i = 0; i < inString.length; i += 1) {
            hash = ((hash << 5) - hash + inString.charCodeAt(i)) & 0xffffffff;
        }
        return [
            'frc',
            name.split('[').join('_').replace(']', ''),
            hash,
        ].join('-');
    }

    async componentDidMount() {
        super.componentDidMount();

        if (this.props.searchWhenEmpty) {
            while (!this.autoSuggestRef?.current) {
                await TB.wait(0)
            }

            return this.onSuggestionsFetchRequested({value: this.props.searchWhenEmpty})
        }
    }


    onChange = (event, { newValue }) => {
        if (this.props.onSearch) {
            this.props.onSearch(newValue);
        }
        if (this.state.search !== newValue) {

            return this.promisedState({
                search: newValue
            });
        }else {
            event.preventDefault();
        }
    };

    async onSuggestionSelected(event, {suggestion, suggestionValue, suggestionIndex, sectionIndex, method})
    {
        if(method === 'enter') event.preventDefault();

        await this.onSuggestionsClearRequested();

        await this.props.onChange(suggestion);

        await this.promisedState({search: this.getSuggestionDisplay(this.props.value) || '', isLoading: false});
    }

    searchEndpoint(search) {
        let endPoint = this.props.searchRequestEndpoint;
        const hasQuery = new RegExp(/\?.+=.*/g);

        if (!hasQuery.test(endPoint)) {
            endPoint += "?";
        }else endPoint += "&"
        endPoint += "search=" + encodeURIComponent(search);

        return endPoint
    }


    onSuggestionsFetchRequested = async({value}) => {
        if (value === this.props.value) {
            console.info('onSuggestionsFetchRequested NO CHANGE')
            return;
        }
        await this.props.onLoading(true);

        if(!this.props.searchRequestEndpoint) {
            await this.promisedState({isLoading: true})

            await TB.wait(300)
            const searched = (item) => {
                return (TB.isString(item) ? item : item?.name || '').trim().toLowerCase().indexOf(value.trim().toLowerCase());
            }

            console.log('onSuggestionsFetchRequested', this.state.searchSuggestions)
            let suggestions = TB.orderBy(TB.filter([...this.state.searchSuggestions],(item) => {
                return searched(item) > -1
            }), (item) => searched(item), 'desc');
            if (!suggestions.length) {
                suggestions.push({empty: true})
            }
            if(this.props.onSuggestionsFetched) {
                await this.promisedState({
                    isLoading: false
                });
                await this.props.onLoading(false)
                return this.props.onSuggestionsFetched(suggestions, value);
            }
            return this.promisedState({
                suggestions,
                isLoading: false
            });
        }

        if(this.SearchRequest?.isRunning()) {
            await this.SearchRequest.cancel();
        }

        let SearchRequest = TB.request(
            TB.api_endpoint(this.searchEndpoint(value))
        );
        try {

            this.SearchRequest = SearchRequest;

            await this.promisedState({isLoading: true})
            await this.props.onLoading(true);

            let response = await this.SearchRequest.get();


            let suggestions =[];
            if(Array.isArray(this.props.searchType)) {
                TB.map(this.props.searchType, type => {
                    let types = TB.map(TB.get(
                        response,
                        `success.data.${type}`,
                        []
                    ), option => {
                        return {
                            ...option,
                            tag_type: type
                        }
                    });
                    suggestions = [...suggestions, ...types]
                });
            }else {
                suggestions = TB.get(
                    response,
                    `success.data.${this.props.searchType}`,
                    []
                );
            }

            if(this.props.onSuggestionsFetched) {
                await this.promisedState({
                    isLoading: false
                });
                await this.props.onLoading(false)
                return this.props.onSuggestionsFetched(suggestions, value);
            }

            if (!suggestions.length) {
                suggestions.push({empty: true})
            }
            await this.promisedState({
                isLoading: false,
                suggestions
            });
            await this.props.onLoading(false)
        }catch(e) {
            if (SearchRequest.didFail && !SearchRequest.wasCancelled) {

                if(this.props.onSuggestionsFetched) {
                    await this.promisedState({isLoading: false});
                    return this.props.onError(true)
                }
                let suggestions = [{error: true}];

                await this.props.onError(true)

                await this.promisedState({isLoading: false, suggestions});
            }
        }
    };

    onSuggestionsClearRequested = (event) => {
        this.props.onChange('');

        this.setState({
            suggestions: [],
            isLoading: false
        });
    };

    getSuggestionDisplay(suggestion) {
        return SearchInput.suggestionDisplay(suggestion, this.props.valueLabelDisplay)
    }

    static suggestionDisplay(suggestion, valueLabel) {

        if (typeof suggestion === 'string') {
            return suggestion
        }else if(typeof valueLabel === 'function') {
            return valueLabel(suggestion)
        }else if(suggestion && suggestion.hasOwnProperty(valueLabel)) {
            return suggestion[valueLabel || 'name'];
        }

        return false;
    }

    render()
    {

        let {
            suggestions,
            search,
            id
        } = this.state;

        let {
            disabled,
            placeholder = '',
            appendAfter = null
        } = this.props;

        // AutoSuggest will pass through all these props to the input.
        const inputProps = {
            id,
            name: 'search-input' + id,
            placeholder,
            value: this.getSuggestionDisplay(this.props.value) || search,
            onChange: this.onChange.bind(this),
            disabled: disabled || this.state.disabled || (!this.props.onSuggestionsFetched && this.getSuggestionDisplay(this.props.value))
        };

        return (
            <div className="flex flex-col items-start">
                <Autosuggest
                    ref={this.autoSuggestRef}
                    suggestions={suggestions}
                    onSuggestionsFetchRequested={(value) => this.onSuggestionsFetchRequested(value)}
                    onSuggestionsClearRequested={() => this.onSuggestionsClearRequested}
                    onSuggestionSelected={this.onSuggestionSelected.bind(this)}
                    getSuggestionValue={suggestion => this.getSuggestionDisplay(suggestion)}
                    focusInputOnSuggestionClick={false}
                    renderSuggestion={this.renderSuggestion.bind(this)}
                    renderSuggestionsContainer={this.renderSuggestionsContainer.bind(this)}
                    shouldRenderSuggestions={(value) => value?.trim?.()?.length >= 1}
                    inputProps={inputProps}
                    renderInputComponent={this.renderInputComponent.bind(this)}/>
                {appendAfter}
            </div>
        )
    }

    renderSuggestionsContainer({ containerProps, children }, isDisabled) {

        const { ref, ...restContainerProps } = containerProps;
        const callRef = isolatedScroll => {
            if (isolatedScroll !== null) {
                ref(isolatedScroll.component);
            }
        };

        if(!restContainerProps.className) {
            restContainerProps.className = "suggest";
        }

        if(isDisabled) restContainerProps.className += " suggestions-disabled";

        return (
            <IsolatedScroll ref={callRef} {...restContainerProps}>
                {children}
            </IsolatedScroll>
        );
    }

    renderSuggestion(suggestion, { query, isHighlighted }) {


        if (!suggestion || suggestion.empty || suggestion.error) return null;

        if (this.props.isSuggestionAvailable) {
            let available = this.props.isSuggestionAvailable(suggestion);
            if (!available) return null
        }

        let key = (suggestion && !suggestion?.empty && !suggestion?.error) ? TB.slugify(this.getSuggestionDisplay(suggestion) || '') : '';

        if (this.props.renderItem) {
            return this.props.renderItem(suggestion, {query, isHighlighted})
        }
        return (
            <p key={"suggestion-" + key}
               className={"suggestion " + (isHighlighted && "highlighted-suggestion")}>

                {this.getSuggestionDisplay(suggestion)}

                {isHighlighted && (
                    <span key={"highlight-" + key} className="suggestion-help">
                        Press enter to select
                    </span>
                )}
            </p>
        );
    }

    renderInputComponent(inputProps) {
        let {
            isLoading,
            suggestions = [],
            search
        } = this.state;

        let {
            value,
            onSuggestionsFetched,
            inputClassName,
            onChange,
            disabled
        } = this.props;

        let hasValue = onSuggestionsFetched ? (
            !isLoading && search !== ''
        ) : this.getSuggestionDisplay(value);


        let empty = false, error = false, emptyOrErrorProps = {};
        if(!isLoading && suggestions.length === 1) {
            empty = TB.find(suggestions, ['empty', true]);
            error = search === '' ? false : TB.find(suggestions, ['error', true]);

            if (empty || error) {
                emptyOrErrorProps = {onKeyDown: e => e.keyCode === 40 && e.preventDefault(), onClick: e => e.preventDefault()}
            }
        }

        return [
            <div key={"input-search+ " + inputProps.name}
                 className={'input-group ' + (inputClassName || ' ')}>

                <input
                    {...inputProps}
                    {...emptyOrErrorProps}
                    className={"form-control"}
                    autoComplete={'off'}
                    autoCapitalize={'words'}
                />

                {(hasValue || empty || error) ? (
                    <span onClick={async (event) => {
                        if (onSuggestionsFetched) {
                            await this.onChange(event, {newValue: ''});
                            onSuggestionsFetched([])
                        }else {
                            await this.promisedState({suggestions: [],search: ''});
                            await onChange({});
                        }

                        this.autoSuggestRef.current?.input?.focus()
                    }} className="clickable input-group-prepend">
                            <i className="fa fa-times"/>
                        </span>
                ) : (isLoading && (
                    <span className="input-group-prepend">
                        {isLoading && !disabled && (
                            <LoadingSpinner/>
                        )}
                    </span>
                ))}
            </div>,
            (empty || error) && (
                <ul key={"suggest-empty-or-error"} className="no-click border-gray-100 w-full react-autosuggest__suggestions-list">
                    <li className="react-autosuggest__suggestion react-autosuggest__suggestion--first">
                        <p className="suggestion-empty suggestion">
                            {empty && '0 results found. Try editing your search or select from the list below.'}
                            {error && 'Something went wrong... Please try again later'}
                        </p>
                    </li>
                </ul>
            )
        ];
    }

    async componentWillUnmount() {
        super.componentWillUnmount();
        if(this.SearchRequest?.isRunning()) {
            await this.SearchRequest.cancel();
        }
    }
}

SearchInput.propTypes = {
    value: PropTypes.any,
    searchType: PropTypes.any,
    valueLabelDisplay: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    onLoading: PropTypes.func,
    onChange: PropTypes.func,
    disabled: PropTypes.any,
    name: PropTypes.string,
    searchRequestEndpoint: PropTypes.any,
    onSuggestionsFetched: PropTypes.any
};

class Search extends Component {


    constructor(props) {
        super(props);

        this.SearchInputRef = React.createRef();

    }

    triggerSearch(value) {
        if (!this.SearchInputRef?.current) return false;

        return this.SearchInputRef.current.onSuggestionsFetchRequested({value});
    }

    render() {
        let {
            searchType,
            valueLabelDisplay,
            searchRequestEndpoint,
            label,
            value,
            renderItem,
            name,
            setValue,
            getValue,
            onChange,
            appendAfter = null,
            onLoading = () => true,
            onError = () => true,
            ...searchInputProps
        } = this.props;

        onChange = (value) => {

            if (this.props.onSuggestionsFetched) {
                return (value)
            }
            let validate = value?.[valueLabelDisplay] && !TB.isEqualWith(value, getValue(), (objValue, othValue) => {
                return objValue?.[valueLabelDisplay] === othValue?.[valueLabelDisplay]
            });

            setValue(value, validate);
        }

        value = getValue() || {};
        let className = this.props.showRequired() ? 'required ' : '';

        className += !this.props.isValid() && this.props.isFormSubmitted() ? 'text-danger' : '';
        let inputClassName = !this.props.isValid() && this.props.isFormSubmitted() ? 'is-invalid' : '';
        if (this.props.disabled) {
            inputClassName += ' disabled'
        }
        const errorMessage = this.props.getErrorMessage();

        return (
            <div className={"form-group " + className}>
                {label && (
                    <label className="col-form-label" data-required={this.props.required}>
                        {label}
                        {this.props.required && <span className="required-symbol"> *</span>}
                    </label>
                )}
                <SearchInput
                    label={label}
                    searchType={searchType}
                    valueLabelDisplay={valueLabelDisplay}
                    value={value}
                    renderItem={renderItem}
                    inputClassName={inputClassName}
                    onChange={onChange}
                    onSearch={(search) => {
                        if (this.props.onSuggestionsFetched) {

                            this.props.setValue(search);

                            if (search === '' && this.props.searchWhenEmpty) {
                                this.triggerSearch(this.props.searchWhenEmpty)
                            }
                        }
                    }}
                    ref={this.SearchInputRef}
                    onError={onError}
                    onLoading={onLoading}
                    searchRequestEndpoint={searchRequestEndpoint}
                    appendAfter={appendAfter}
                    {...searchInputProps}
                />
                {errorMessage && (
                    <div className="invalid-feedback">
                        <div>{errorMessage}</div>
                    </div>
                )}
            </div>
        )

    }
}

const SearchFormInput = withFormsy(Search);
export {SearchInput};
export default SearchFormInput;